import { useQuery } from '@tanstack/react-query'
import { compact, keyBy } from 'lodash'

import { RecordFactory } from '../models/RecordFactory'
import { Subaccount } from '../models/Subaccount'

// Given an array of subaccounts, pulls the associated client user for each and returns a map
// of them by their ID.
export const useSubaccountParentUsersByID = (subaccounts: Subaccount[], isEnabled: boolean) => {
    return useQuery({
        queryKey: ['subaccount-parent-users', subaccounts],
        queryFn: async () => {
            const subaccountUserIDs = compact(
                subaccounts.map((subaccount) => subaccount.client?.id)
            )
            if (subaccountUserIDs.length === 0) {
                return {}
            }

            const users = compact(
                await Promise.all(
                    subaccountUserIDs.map((id) => RecordFactory.getInstance().loadUser(id))
                )
            )
            return keyBy(users, (user) => user.id ?? '')
        },
        enabled: isEnabled,
    })
}
